<template>
  <div class="footer" :style="{
    backgroundColor: dataStyle.bg_color
  }">
    <div class="zy-container footer-container">
      <div class="title">联系我们</div>
      <div class="qrcodes">
        <template v-for="(item, idx) in dataStyle.about_us">
          <div v-if="item.is_show === '1'" :key="'qrcode_' + idx" class="qrcode">
            <img class="image" :src="item.qrcode"/>
            <div class="desc" :style="{
            color: item.title_color
          }">
              <img class="icon" :src="item.icon"/>
              {{item.title}}
            </div>
          </div>
        </template>

      </div>

      <a href="http://beian.miit.gov.cn" target="_blank" class="copyright">{{dataStyle.copyright}}</a>
    </div>

  </div>
</template>

<script>
export default {
  name: "ZyFooter",
  props: {
    mod: Object
  },
  computed: {
    dataStyle() {
      return this.mod && this.mod.data ? JSON.parse(this.mod.data) : undefined
    }
  },
}
</script>

<style scoped lang="scss">
.footer {
  background-color: #F5D1F92B;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: center;

  .footer-container {
    margin-top: 4.6vw;
    margin-bottom: 4.6vw;
    display: flex;
    flex-direction: column;
    align-items: center;

    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }

  .title {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
  }

  .qrcodes {
    display: flex;
    margin-top: 4px;
    margin-bottom: 4.6vw;
    padding-top: 10px;
    .qrcode {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 20px;

      .image {
        width: 108px;
        height: 108px;
      }
      .desc {
        display: flex;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        margin-top: 4px;

        .icon {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          object-fit: contain;
        }
      }

    }
  }

  .copyright {
    font-size: 14px;
    color: #666666;
    line-height: 30px;
    text-align: center;
  }
}
</style>
